import api from '@/lib/axios';
import type { LoginRequest, LoginResponse, User, ApiResponse } from '@/types';

/**
 * Service de Autenticação
 * Rotas: /v1/autenticacao/*
 * Suporta fallback para porta alternativa (8000/8001)
 */
export const authService = {
  /**
   * Login do usuário
   * POST /v1/autenticacao/entrar
   * Tenta primeiro a porta principal, depois fallback
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const payload = {
      login: credentials.email,  // o backend aceita e-mail ou usuário no campo login
      password: credentials.password,
    };
    const { data } = await api.post<ApiResponse<LoginResponse>>('/v1/autenticacao/entrar', payload);
    return data.data;
  },

  /**
   * Logout do usuário
   * POST /v1/autenticacao/sair
   */
  async logout(): Promise<void> {
    await api.post('/v1/autenticacao/sair');
  },

  /**
   * Obter usuário autenticado
   * GET /v1/autenticacao/usuario-atual
   */
  async me(): Promise<User> {
    const { data } = await api.get<ApiResponse<User>>('/v1/autenticacao/usuario-atual');
    return data.data;
  },

  /**
   * Refresh do token
   * POST /v1/autenticacao/renovar
   */
  async refresh(): Promise<LoginResponse> {
    const { data } = await api.post<ApiResponse<LoginResponse>>('/v1/autenticacao/renovar');
    return data.data;
  },

  /**
   * Iniciar impersonation de um usuário (somente conta mestre)
   * POST /v1/acessar-como/iniciar/{userId}
   */
  async takeImpersonation(userId: number, reason: string): Promise<LoginResponse> {
    const { data } = await api.post<ApiResponse<LoginResponse>>(`/v1/acessar-como/iniciar/${userId}`, { reason });
    return data.data;
  },

  /**
   * Sair da impersonation (invalida token temporário no backend)
   * POST /v1/acessar-como/sair
   */
  async leaveImpersonation(): Promise<void> {
    await api.post('/v1/acessar-como/sair');
  },

  async forcePasswordReset(payload: {
    current_password: string;
    new_password: string;
    new_password_confirmation: string;
  }): Promise<User> {
    const { data } = await api.post<ApiResponse<{ user: User }>>(
      '/v1/autenticacao/forcar-redefinicao-de-senha',
      payload,
    );
    return data.data.user;
  },
};
